module.exports = __webpack_public_path__ + "img/social-email-2.c431d7e4.svg";